import React, {useEffect, useState} from "react";
import './Settings.css';
import {deleteData, getPersonalData} from "../../api/user/UserApi";
import {ApiError, ErrorCode} from "../../api/ApiError";
import {WarningButton} from "../common/Buttons";
import {MembershipLevel, useUserContext} from "../../context/userContext";
import NotFoundSegment from "../notfound/NotFoundSegment";
import {useAuthorizationContext} from "../../context/authorizationContext";
import {getPlaylistSettings, updatePlaylistSettings} from "../../api/playlistpreferences/PlaylistPreferencesApi";
import {Setting} from "../../api/playlistpreferences/PlaylistPreferences";
import PageSegmentLoading from "../common/PageSegmentLoading";
import {Toggle} from "../common/Toggle";
import './UserPersonalData.css';

export const UserPersonalData = () => {
    const {loggedIn} = useAuthorizationContext();
    const [personalData, setPersonalData] = useState<string>();

    useEffect(() => {
        getPersonalData()
            .then((data: string) => {
                const parsed = JSON.parse(data);
                const formatted = JSON.stringify(parsed, null, 2);
                setPersonalData(formatted);
            });
    }, []);


    if (loggedIn !== true) {
        return <NotFoundSegment/>
    }

    if (personalData == undefined) {
        return <PageSegmentLoading/>
    }

    return (
        <div>
            <div className="pageContentSegment">
                <h1>My Personal Data</h1>
                <textarea className={"personalDataContainer"} value={personalData}/>
            </div>
        </div>
    )
}